import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { VitalsService } from '../../vitals/services/vitals.service'
import { IPainQualityFieldOptionsResponse } from '../../../common/common.types'
import { setSedationScaleOptions } from '../store/options.actions'

export function* getSedationScaleOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const response: IPainQualityFieldOptionsResponse = yield call([
      vitalsService,
      vitalsService.getSedationScaleOptions,
    ])
    const { entity } = response
    yield put(setSedationScaleOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getSedationScaleOptions() error: ${e}`))
  }
}

export function* getSedationScaleOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getSedationScaleOptions)
}
